"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MAX_HAMBURGER_WIDTH = void 0;
const MAX_HAMBURGER_WIDTH = exports.MAX_HAMBURGER_WIDTH = 1079;
const breakPoints = [{
  name: 'smallPhone',
  maxWidth: 400,
  columns: 1
}, {
  name: 'mediumPhone',
  maxWidth: 520,
  columns: 1
}, {
  name: 'largePhone',
  maxWidth: 680,
  columns: 1
}, {
  name: 'smallTablet',
  maxWidth: 751,
  columns: 1
}, {
  name: 'tablet',
  maxWidth: 1024,
  columns: 2
}, {
  name: 'smallDesktop',
  maxWidth: 1199,
  columns: 3
}, {
  name: 'desktop',
  maxWidth: 1300,
  columns: 3
}, {
  name: 'largeDesktop',
  maxWidth: Number.MAX_SAFE_INTEGER,
  columns: 3
}, {
  name: 'sharedHeaderStacked',
  maxWidth: 1160,
  columns: 1
}, {
  name: 'sharedHeaderMobile',
  maxWidth: 750,
  columns: 1
}];
var _default = exports.default = breakPoints;